module.exports = __webpack_public_path__ + "static/media/7.7eac56e5.jpg";